// API Configuration for Multiple Backends
// HomeQuest Tech - Dual API Architecture

export const API_ENDPOINTS = {
  // Primary API - AI, Vision, Heavy Processing
  primary: {
    url: import.meta.env.VITE_API_URL || 'https://homequest-api-1.onrender.com',
    endpoints: {
      // AI & Vision
      floorPlan: '/api/floor-plan',
      cubicasa: '/api/cubicasa',
      vision: '/api/production-blueprint',

      // Weather & Environmental
      weather: '/api/weather',

      // Heavy Processing
      analytics: '/api/analytics',
      reports: '/api/reports'
    }
  },

  // Team API - Projects, Collaboration, Real-time
  team: {
    url: import.meta.env.VITE_TEAM_API_URL || 'https://homequest-api-1.onrender.com',
    endpoints: {
      // Projects & Teams
      projects: '/api/projects',
      teams: '/api/teams',
      contacts: '/api/contacts',

      // Collaboration
      messages: '/api/messages',
      notifications: '/api/notifications',

      // Authentication
      auth: '/api/auth',
      users: '/api/users'
    }
  }
};

// Helper function to get full endpoint URL
export const getApiUrl = (apiType?: 'primary' | 'team', endpoint?: string): string => {
  // Sanitize URL to fix protocol casing and whitespace issues
  const sanitizeUrl = (url: string): string => {
    return url.trim().toLowerCase().replace(/^https:/, 'https:');
  };

  // If no parameters provided, return base URL (for backward compatibility)
  if (!apiType) {
    // ALWAYS return the actual API URL - no more relative paths
    // This fixes the issue where API calls were going to the frontend domain
    const url = sanitizeUrl(API_ENDPOINTS.primary.url);
    console.log('[API Config] Returning URL:', url);
    return url;
  }

  // Original functionality when parameters are provided
  const api = API_ENDPOINTS[apiType];
  if (!endpoint) {
    return sanitizeUrl(api.url);
  }
  return `${sanitizeUrl(api.url)}${api.endpoints[endpoint as keyof typeof api.endpoints] || endpoint}`;
};

// Fetch with authentication
export const fetchWithAuth = async (apiType: 'primary' | 'team', endpoint: string, options: RequestInit = {}) => {
  const token = localStorage.getItem('sb-fbwmkkskdrvaipmkddwm-auth-token');
  const url = getApiUrl(apiType, endpoint);

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    const parsedToken = JSON.parse(token);
    headers['Authorization'] = `Bearer ${parsedToken.access_token}`;
  }

  return fetch(url, {
    ...options,
    headers
  });
};

// Export individual API URLs for backward compatibility
export const API_URL = API_ENDPOINTS.primary.url;
export const TEAM_API_URL = API_ENDPOINTS.team.url;